import { FC } from 'react'
import { observer } from 'mobx-react'
import styles from './index.module.scss'
import { IPublicUser } from '../../../types'
import { getUserAvatar } from '../../../utils'
import { AvatarWithVerifiedBadge } from '../AvatarWithVerifiedBadge'
import { UserDetailShareAndReportContent } from '../UserDetailShareAndReportContent'

type Props = {
  user: IPublicUser
}

export const UserDetailHeaderTitle: FC<Props> = observer(({ user }) => {
  return (
    <div className={styles.container}>
      <div className={styles.avatar}>
        <AvatarWithVerifiedBadge avatar={getUserAvatar(user)} name={user?.name} />
      </div>
      <div className={styles.link}>
        <UserDetailShareAndReportContent user={user} />
      </div>
    </div>
  )
})
